import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'

// 解决路由冗余报错问题
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Index',
        component: () => import ('@views/MainContent'),
        redirect: () => ({ name: 'Home' }),
        children: [
            {
                path: 'home',
                name: 'Home',
                component: () => import ('@views/home/Home')
            },
            {
                path: 'front_pc',
                name: 'FrontPC',
                component: () => import ("@/views/front_pc/FrontPC.vue")
            },
            {
                path: 'voiceguide_qrcode',
                name: 'voiceguide_qrcode',
                component: () => import ("@/views/qrcode/Qrcode.vue")
            },
            {
                path: 'media',
                name: 'media',
                component: () => import ('@/views/modelmanage/ModelManage'),
                // component: () => import ("@/views/media_manage/MediaManage.vue"),
            },
            {
                path: 'modelmanage/:index/name_zn/:name',
                name: 'ModelManage',
                component: () => import ('@/views/modelmanage/ModelManage'),
            },
            {
                path: 'column_config',
                name: 'ColumnConfig',
                component: () => import ("@/views/system_config/columnconfig/ColumnConfig.vue"),
            },
            {
                path: 'account_manage',
                name: 'AccountManage',
                component: () => import ("@/views/system_config/account_manage/AccountManage.vue"),
            },
            {
                path: 'role_manage',
                name: 'RoleManage',
                component: () => import ("@/views/system_config/role_manage/RoleManage.vue"),
            },
            {
                path: 'department_manage',
                name: 'DepartmentManage',
                component: () => import ("@/views/system_config/department_manage/DepartmentManage.vue"),
            },
            {
                path: 'params_config',
                name: 'ParamsConfig',
                component: () => import ("@/views/system_config/params_config/ParamsConfig.vue"),
            }
        ]
    },
    {
        path: '/loginpage',
        name: 'LoginPage',
        component: () => import ('@/login/login')
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.name == 'FullScreen') {
        sessionStorage.setItem('pathName', 'FullScreen')
    }else if (to.name !== 'LoginPage' && !store.state.login_status) {
        next({ name: 'LoginPage' })
    }else{
        next()
    }
})

export default router